import React from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleDDL from "../../../../modules/SimpleDDL";
import Button from "../../../../modules/commons/Button";

export const tableConfigDetailOtherItem = {
  withQR: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "kodeOtherItem",
      label: "Kode Barang Lain",
      options: {
        sort: false,
      },
    },
    {
      name: "namaOtherItem",
      label: "Nama Barang Lain",
      options: {
        sort: false,
      },
    },
    {
      name: "categoryotheritem",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "qty",
      label: "Qty",
      options: {
        customBodyRender: (value) => {
          return !value ? 1 : value;
        },
        sort: false,
      },
    },
    {
      name: "satuan",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "barcode",
      label: "QR Code",
      options: {
        sort: false,
      },
    },
  ],
  withoutQR: (changeValue, deleteRow) => [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "kodeOtherItem",
      label: "Kode Barang Lain",
      options: {
        sort: false,
      },
    },
    {
      name: "namaOtherItem",
      label: "Nama Barang Lain",
      options: {
        sort: false,
      },
    },
    {
      name: "categoryotheritem",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "qty",
      label: "Qty",
      options: {
        sort: false,
      },
    },
    {
      name: "satuan",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "actualQty",
      label: "Act Qty",
      options: {
        sort: false,
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val == "" ? 0 : val;
          }
          return (
            <SimpleInput
              id="input_act_qty"
              name="actualQty"
              box="number"
              value={val}
              onValueChange={({ value }) => {
                changeValue(rowIndex, "actualQty", value);
                changeValue(
                  rowIndex,
                  "diffQty",
                  Number(value) - (rowData[4] || 0),
                );
              }}
            />
          );
        },
      },
    },
    {
      name: "diffQty",
      label: "Diff Qty",
      options: {
        sort: false,
        customBodyRender: (val, { rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val;
          }
          return (
            <SimpleInput
              id="input_act_qty"
              name="diffQty"
              box="number"
              readOnly
              value={val}
              onChange={() => {}}
            />
          );
        },
      },
    },
    {
      name: "note",
      label: "Keterangan",
      options: {
        sort: false,
        customBodyRender: (val, { rowIndex, rowData }) => {
          const isSaved = rowData[rowData.length - 1];
          if (isSaved) {
            return val;
          }
          return (
            <SimpleInput
              id="input_act_qty"
              name="note"
              value={val}
              onChange={({ target }) =>
                changeValue(rowIndex, "note", target.value)
              }
            />
          );
        },
      },
    },
    {
      name: "isSaved",
      label: "Aksi",
      options: {
        sort: false,
        customBodyRender: (val, { rowIndex }) => {
          return (
            <FlexView style={{ gap: "15px" }}>
              {val ? (
                <Button
                  className="btnAct"
                  onClick={(e) => {
                    e.preventDefault();
                    changeValue(rowIndex, "isSaved", false);
                  }}
                >
                  <i
                    className="fa fa-pencil-alt"
                    style={{
                      fontSize: 20,
                      color: "red",
                    }}
                  />
                </Button>
              ) : (
                <Button
                  className="btnAct"
                  onClick={(e) => {
                    e.preventDefault();
                    changeValue(rowIndex, "isSaved", true);
                  }}
                >
                  <i
                    className="fa fa-save"
                    style={{
                      fontSize: 20,
                      color: "red",
                    }}
                  />
                </Button>
              )}
              <Button
                className="btnAct"
                onClick={(e) => {
                  e.preventDefault();
                  deleteRow(rowIndex, "dataTable");
                }}
              >
                <i
                  className="fa fa-times-circle"
                  style={{
                    fontSize: 20,
                    color: "red",
                  }}
                />
              </Button>
            </FlexView>
          );
        },
      },
    },
  ],
};

export const tableConfigOtherItemReportSO = {
  withQR: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "dataOtherItem.kodeotheritem",
      label: "Kode Barang Lain",
      options: {
        sort: false,
      },
    },
    {
      name: "dataOtherItem.nameotheritem",
      label: "Nama Barang Lain",
      options: {
        sort: false,
      },
    },
    {
      name: "dataOtherItem.categoryDTO.value",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "dataOtherItem.qty",
      label: "Qty",
      options: {
        customBodyRender: (value) => {
          return !value ? 1 : value;
        },
        sort: false,
      },
    },
    {
      name: "dataOtherItem.satuanDTO.value",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "barcode",
      label: "QR Code",
      options: {
        sort: false,
      },
    },
    {
      name: "exist",
      label: "Status",
      options: {
        sort: false,
        customBodyRender: (val) => {
          return val ? "DITEMUKAN" : "TIDAK DITEMUKAN";
        },
      },
    },
    {
      name: "userId",
      label: "User",
      options: {
        sort: false,
        customBodyRender: (value) => {
          if (!value) return "-";
          return value.name || "-";
        },
      },
    },
  ],
  withoutQR: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "dataOtherItem.kodeotheritem",
      label: "Kode Barang Lain",
      options: {
        sort: false,
      },
    },
    {
      name: "dataOtherItem.nameotheritem",
      label: "Nama Barang Lain",
      options: {
        sort: false,
      },
    },
    {
      name: "dataOtherItem.categoryDTO.value",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "qty",
      label: "Qty",
      options: {
        sort: false,
        customBodyRender: (val) => {
          return val || 0;
        },
      },
    },
    {
      name: "dataOtherItem.satuanDTO.value",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "actualQty",
      label: "Act Qty",
      options: {
        sort: false,
      },
    },
    {
      name: "diffQty",
      label: "Diff Qty",
      options: {
        sort: false,
      },
    },
    {
      name: "note",
      label: "Keterangan",
      options: {
        sort: false,
      },
    },
    {
      name: "userId",
      label: "User",
      options: {
        sort: false,
        customBodyRender: (value) => {
          if (!value) return "-";
          return value.name || "-";
        },
      },
    },
  ],
};

export const tableConfigOtherItemKelebihan = (
  ddlItems = [],
  onChange,
  dataKelebihan,
  changeValue,
  deleteRow,
  dataKekurangan,
) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

        return <>{rowNumber}</>;
      },
    },
  },
  {
    name: "item.kodeotheritem",
    label: "Kode Barang Lain",
    options: {
      sort: false,
    },
  },
  {
    name: "item.nameotheritem",
    label: "Nama Barang Lain",
    options: {
      sort: false,
      customBodyRender: (value, tableMeta) => {
        const rowIndex = tableMeta.rowIndex;
        const currentRow = dataKelebihan?.listDataTanpaQR?.[rowIndex];
        const isSaved = currentRow?.isSaved;
        const textError = dataKelebihan?.errorsTanpaQR?.[rowIndex]?.code;

        const selectedKelebihan =
          dataKelebihan?.listDataTanpaQR
            ?.filter((_, i) => i !== rowIndex) 
            ?.map((item) => item?.item?.kodeotheritem) || [];

        const selectedKekurangan =
          dataKekurangan?.map((item) => item?.item?.kodeotheritem) || [];

        const allSelected = [...selectedKelebihan, ...selectedKekurangan];
        const currentKode = currentRow?.item?.kodeotheritem;

        const filteredOptions = ddlItems.filter((opt) => {
          if (opt.value === currentKode) return true;
          return !allSelected.includes(opt.value);
        });

        const val = currentKode
          ? {
              value: currentKode,
              label: currentRow?.item?.nameotheritem,
            }
          : null;

        if (isSaved) return val?.label || "-";

        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <SimpleDDL
              id={`ddl_other_${rowIndex}`}
              containerclassname="margin-bottom-none width width-200px"
              name="nameotheritem"
              options={filteredOptions}
              isClearable
              value={val}
              box="search"
              menuPosition="fixed"
              onChange={(opt) => onChange(rowIndex, "nameotheritem", opt)}
            />

            {textError && (
              <span
                style={{
                  color: "red",
                  fontSize: "12px",
                  marginTop: "4px",
                }}
              >
                {textError}
              </span>
            )}
          </div>
        );
      },
    },
  },
  {
    name: "item.categoryDTO.value",
    label: "Kategori",
    options: {
      sort: false,
    },
  },
  {
    name: "systemQty",
    label: "Qty",
    options: {
      sort: false,
      customBodyRender: (val) => {
        return val || 0;
      },
    },
  },
  {
    name: "item.satuanDTO.value",
    label: "Satuan",
    options: {
      sort: false,
    },
  },
  {
    name: "diffQty",
    label: "Diff Qty",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = dataKelebihan?.listDataTanpaQR?.[rowIndex]?.isSaved;
        const textError = dataKelebihan?.errorsTanpaQR?.[rowIndex]?.diffQty;
        if (isSaved) return val ?? "";

        const safeValue =
          typeof val === "string" ? val.replace("+", "") : (val ?? "");

        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <SimpleInput
              id="input_act_qty"
              name="diffQty"
              box="onlyNumber"
              containerclassname="margin-bottom-none width width-80px"
              value={val}
              onChange={(e) =>
                onChange(rowIndex, "diffQty", Number(e.target.value || 0))
              }
            />

            {textError && (
              <span
                style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
              >
                {textError}
              </span>
            )}
          </div>
        );
      },
    },
  },
  {
    name: "notes",
    label: "Keterangan",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex, rowData }) => {
        const isSaved = dataKelebihan?.listDataTanpaQR?.[rowIndex]?.isSaved;
        const textError = dataKelebihan?.errorsTanpaQR?.[rowIndex]?.notes;
        if (isSaved) {
          return val;
        }
        return (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <SimpleInput
              id="input_act_qty"
              name="notes"
              containerclassname="margin-bottom-none width width-200px"
              value={val}
              onChange={({ target }) =>
                onChange(rowIndex, "notes", target.value)
              }
            />

            {textError && (
              <span
                style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
              >
                {textError}
              </span>
            )}
          </div>
        );
      },
    },
  },
  {
    name: "isSaved",
    label: "Aksi",
    options: {
      sort: false,
      customBodyRender: (val, { rowIndex }) => {
        return (
          <FlexView style={{ gap: "15px" }}>
            {val ? (
              <Button
                className="btnAct"
                onClick={(e) => {
                  e.preventDefault();
                  if (typeof changeValue === "function") {
                    changeValue(rowIndex, "isSaved", false);
                  }
                }}
              >
                <i
                  className="fa fa-pencil-alt"
                  style={{
                    fontSize: 20,
                    color: "red",
                  }}
                />
              </Button>
            ) : (
              <Button
                className="btnAct"
                onClick={(e) => {
                  e.preventDefault();
                  if (typeof changeValue === "function") {
                    changeValue(rowIndex, "isSaved", true);
                  }
                }}
              >
                <i
                  className="fa fa-save"
                  style={{
                    fontSize: 20,
                    color: "red",
                  }}
                />
              </Button>
            )}

            <Button
              className="btnAct"
              onClick={(e) => {
                e.preventDefault();
                if (typeof deleteRow === "function") {
                  deleteRow(rowIndex);
                }
              }}
            >
              <i
                className="fa fa-times-circle"
                style={{
                  fontSize: 20,
                  color: "red",
                }}
              />
            </Button>
          </FlexView>
        );
      },
    },
  },
];

export const tableConfigOtherItemKekurangan = {
  withQR: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "dataOtherItem.kodeotheritem",
      label: "Kode Barang Lain",
      options: {
        sort: false,
      },
    },
    {
      name: "dataOtherItem.nameotheritem",
      label: "Nama Barang Lain",
      options: {
        sort: false,
      },
    },
    {
      name: "dataOtherItem.categoryDTO.value",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "dataOtherItem.qty",
      label: "Qty",
      options: {
        customBodyRender: (value) => {
          return !value ? 1 : value;
        },
        sort: false,
      },
    },
    {
      name: "dataOtherItem.satuanDTO.value",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "otherBarcode",
      label: "QR Code",
      options: {
        sort: false,
      },
    },
  ],
  withoutQR: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
      },
    },
    {
      name: "item.kodeotheritem",
      label: "Kode Barang Lain",
      options: {
        sort: false,
      },
    },
    {
      name: "item.nameotheritem",
      label: "Nama Barang Lain",
      options: {
        sort: false,
      },
    },
    {
      name: "item.categoryDTO.value",
      label: "Kategori",
      options: {
        sort: false,
      },
    },
    {
      name: "systemQty",
      label: "Qty",
      options: {
        sort: false,
        customBodyRender: (val) => {
          return val || 0;
        },
      },
    },
    {
      name: "item.satuanDTO.value",
      label: "Satuan",
      options: {
        sort: false,
      },
    },
    {
      name: "differenceQty",
      label: "Diff Qty",
      options: {
        sort: false,
      },
    },
    {
      name: "note",
      label: "Keterangan",
      options: {
        sort: false,
      },
    },
  ],
};
